import Common from "../../../Common";

const Changes = class extends Common {
	read = (companyId: id): CustomResponse<PbxChanges> =>
		this.get(`/company/${companyId}/pbx/changes`)
}

export default Changes
